// extracted by mini-css-extract-plugin
export default {"examName":"ExamQuestionList_examName__7HHg+","questionItem":"ExamQuestionList_questionItem__a3zYs"};